import { useRequiredPrepMillisecond } from "@/components/features/items/edit/_shared/ui/components/main/questions/required-prep-milli/hooks";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomRequiredPrepMillisecond = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { requiredPrepMillisecond, requiredPrepMillisecondBeforeHour, requiredPrepMillisecondBeforeDate } = viewModel;

	return useRequiredPrepMillisecond({
		requiredPrepMillisecond,
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
		onSet: onSetViewModel,
	});
};
